angular.module('qkr.merchant.reports').controller('StickerController',
    ($scope, $rootScope, $uibModalInstance, $timeout, savedReport, reportService, menuService,
     appConfig, reportsErrorService, utils, merchantService, gettextCatalog) => {
    const now = new Date() * 1;
	const defaultScheduleInterval = 'daily';
    const reportType = 'Stickers';
    const defaultScheduleHour = 17;
    const defaultScheduleMinute = 0;
    const defaultScheduleDay = utils.getDaysOfWeek()[0].name;
    const defaultScheduleDayOfMonth = 1;

    const isSavedReport = !!savedReport;

    const vm = $scope;

    vm.canteenMenus = [];

    vm.daysOfMonth = reportService.getDaysOfMonth();
    // Drop down menu to choose which day to generate weekly report
    vm.daysOfWeek = utils.getDaysOfWeek();
    // Used to select which days a daily report should be generated on
    vm.days = utils.getDaysOfWeekWithSelected();
    vm.scheduleIntervals = reportService.getAnytimeMenuScheduleIntervals();
    vm.hours = reportService.getHours();
    vm.minutes = reportService.getMinutes();

    vm.form = {};

    vm.stickerReportSettings = {
        reportWaiting: false,
        reportUrl: '',
        cutOffTime: '',
        leadTime: 0,
        categoryCutOffTime: '',
        categoryLeadTime: 0,
        categoryScheduleTime: null,
        areAllCategoriesSelected: false,
        showGenerateButton: !(isSavedReport || merchantService.behaviour(merchantService.merchantInfo,
            'reportPage.collapseHeaders')),
        groupByList: [],
        template: {
            groupByList: [],
            filterBy: 'Category'
        }
    };

    vm.stickerReport = {
        date: {
            startDate: now,
            startTime: reportService.getDateTime(0, 0, 0),
            endDate: now,
            endTime: reportService.getDateTime(23, 59, 59)
        },
        startTime: now,
        endTime: null,
        reportSpec: {
            groupBy: []
        }
    };

    vm.stickerReportTemplate = {
        reportSpec: {
            reportSubType: reportType,
            scheduleInterval: defaultScheduleInterval,
            scheduleHour: defaultScheduleHour,
            scheduleMinute: defaultScheduleMinute,
            scheduleDay: defaultScheduleDay,
            scheduleDayOfMonth: defaultScheduleDayOfMonth,
            emailList: [],
            groupBy: []
        }
    };

    var poll = function(id, format, reportType) {
        const timeoutPoll = $timeout(() => {
            // Poll for report

            reportService.pollReport(id)
                .then((promise) => {
                    // Check if error on the report
                    if (promise.error) {
                        handleGenerateReportError(promise);
                    } else if (promise.reportType === 'no-data') {
                        vm.form.stickerReportForm.errors = {generate: gettextCatalog.getString('No data for this date')};
                        vm.stickerReportSettings.reportWaiting = false;
                    }
                    // Check if complete, otherwise poll again
                    else if (promise.percentComplete === 100) {
                        vm.form.stickerReportForm.errors = {};
                        vm.stickerReportSettings.reportWaiting = false;
                        vm.stickerReportSettings.reportUrl = appConfig.apiUrl + 'reportControl/' + promise.id + '/' + format;
                        window.location = vm.stickerReportSettings.reportUrl;
//                        $modalInstance.close();
                    } else {
                        poll(id, format, reportType);
                    }
            },
            (error) => {
                handleGenerateReportError(error);
            });
        }, 2500);

        // When the DOM element is removed from the page, AngularJS will trigger the $destroy event on
        // The scope. This gives us a chance to cancel any pending timer that we may have.
        vm.$on(
            '$destroy',
            (event) => {
                $timeout.cancel(timeoutPoll);
            }
        );
    };

    var handleGenerateReportError = function(error) {
        let errors = {};

        if (vm.form.stickerReportForm.errors) {
            errors = vm.form.stickerReportForm.errors;
        }

        errors.generate = gettextCatalog.getString('Error generating report');
        vm.form.stickerReportForm.errors = errors;
        vm.stickerReportSettings.reportWaiting = false;
    };

    const loadCanteenMenus = function() {
        vm.loading = true;

        reportService.getStickerReportFilters().then((promise) => {
            vm.canteenMenus = promise.menuFilterData;
            if(vm.canteenMenus.length>0) {
                if (savedReport) {
                    angular.forEach(vm.canteenMenus, (menu) => {
                        if (savedReport.prodGroup.id === menu.id) {
                        setupForMenu(menu);
                        setCategoryCutOffTime(menu, savedReport);
                    }
                });
                } else {
                    setupForMenu(vm.canteenMenus[0]);
                }
            }
            if (vm.stickerReportTemplate.reportSpec.prodGroup) {
                setCutOffTime(vm.stickerReportTemplate.reportSpec.prodGroup.id);
            }
            vm.loading = false;
        },
        (error) => {
            handleGenerateReportError(error);
        });
    };

    var setupForMenu = function(prodGroup) {
        vm.stickerReport.reportSpec.prodGroup = {id: prodGroup.id};

        vm.stickerReportSettings.groupByList = prodGroup.customFields;
        vm.stickerReportSettings.stickerReportFilters = {filtersList: prodGroup.filters};
        vm.stickerReportSettings.filterBy = null;
        vm.isAnytimeMenu = !prodGroup.availability.fixedPreorderType && !prodGroup.availability.isPreorderable;

        if (!savedReport) {
            vm.stickerReportTemplate.reportSpec.prodGroup = {id: prodGroup.id};
            vm.stickerReportSettings.template.groupByList = prodGroup.customFields;
            vm.stickerReportSettings.template.stickerReportFilters = {filtersList: prodGroup.filters};
            vm.stickerReportSettings.template.filterBy = null;

            // Sort by whether selected or not (selected by default if in merchant options - I don't know how they get in there)
            var order = 100; // Default position in list (100, 101, 102,...)
            angular.forEach(prodGroup.customFields, (customField) => {
                if (customField.selected) {
                    customField.order = order - 50; // Selected come before unselected
                } else {
                    customField.order = order;
                }
                order = order + 1;
            });
            if (prodGroup.customFields) {
                prodGroup.customFields.sort(sortProdGroupCustomFields);
            }
        } else {
            vm.stickerReportSettings.template.groupByList = prodGroup.customFields;
            vm.stickerReportSettings.template.stickerReportFilters = {filtersList: prodGroup.filters};

            // Need to restore selected groupBy and filters
            if (savedReport.groupBy.length > 0) {
                var order = 100; // Default position in list (100, 101, 102,...)
                angular.forEach(prodGroup.customFields, (customField) => {
                    customField.selected = false;
                    customField.order = order;
                    order = order + 1;
                });
                angular.forEach(prodGroup.customFields, (customField) => {
                    const posInList = savedReport.groupBy.indexOf(customField.name);
                    if (posInList != -1) {
                        customField.selected = true;
                        customField.order = posInList; // Position in savedReport (less than default position)
                    }
                });
                // Now sort by "order" - fields in savedReport will come first
                if (prodGroup.customFields) {
                    prodGroup.customFields.sort(sortProdGroupCustomFields);
                }
            }

            angular.forEach(prodGroup.filters, (filter) => {
                angular.forEach(filter.options, (option) => {
                    if (savedReport.filterMap[filter.name]) {
                        option.selected = isInFilterMap(savedReport.filterMap[filter.name], option.name);
                    }
                });
            });
        }

        vm.reducedFilterList = [];

        angular.forEach(vm.stickerReportSettings.template.stickerReportFilters.filtersList, (filter) => {
            if (utils.hasNoValue(filter.prodgroup) || filter.prodgroup.id === vm.stickerReportTemplate.reportSpec.prodGroup.id) {
                vm.reducedFilterList.push(filter);
            }
        });

        // Checking if is an object because for some reason when it loads template.filter has a string value
        if (!vm.stickerReportSettings.template.filterBy || !_.isObject(vm.stickerReportSettings.template.filterBy)) {
            // Default the selected one to the first in the list
            vm.stickerReportSettings.template.filterBy = vm.reducedFilterList[0];
        }
    };

    var sortProdGroupCustomFields = function(a, b) {
        return a.order - b.order;
    };

    var isInFilterMap = function(options, optionName) {
        return (options.indexOf(optionName) != -1);
    };

    var setCutOffTime = function(prodGroupId) {
        let text;

        // Find the menu
        for (let i = 0; i < vm.canteenMenus.length; i++) {
            if (vm.canteenMenus[i].id === prodGroupId) {
                const menu = vm.canteenMenus[i];

                if (!menu.availability.cutoffOffsetInMinutes) {
                    text = '(' + gettextCatalog.getString('No Cut Off Time Set') + ')';
                } else {
                    text = '(' + utils.formatCutOff(menu.availability.cutoffOffsetInMinutes) + ')';
                    vm.stickerReportSettings.leadTime = utils.getCutOff(menu.availability.cutoffOffsetInMinutes).cutoffDays;
                }
            }
        }
        vm.stickerReportSettings.cutOffTime = text;
    };

    var setCategoryCutOffTime = function(prodGroup, savedReport) {
        if (savedReport.addMenuItemsWithLeadTime && savedReport.filterMap.Category) {
            const filterList = savedReport.filterMap.Category;
            const categoryFilter = filterList.join(',');
            menuService.getLatestItemAvailabilityForCategories(prodGroup.id, categoryFilter).then((promise) => {
                if (promise.cutoffOffsetInMinutes) {
                    const text = '(' + utils.formatCutOff(promise.cutoffOffsetInMinutes) + ')';
                    vm.stickerReportSettings.categoryLeadTime = utils.getCutOff(promise.cutoffOffsetInMinutes).cutoffDays;
                    vm.stickerReportSettings.categoryCutOffTime = text;
                    vm.stickerReportSettings.categoryScheduleTime = promise.cutoffOffsetInMinutes;
                }
            });
        }
    };

    vm.$watch('stickerReport.reportSpec.prodGroup.id', (newProdGroupId, oldProdGroupId) => {
        changeMenu(newProdGroupId);
    });

    vm.$watch('stickerReportTemplate.reportSpec.prodGroup.id', (newProdGroupId, oldProdGroupId) => {
        changeMenu(newProdGroupId);
    });

    var changeMenu = function(newProdGroupId) {
        if (newProdGroupId) {
            let newProdGroup;
            angular.forEach(vm.canteenMenus, (prodGroup) => {
                if (prodGroup.id === newProdGroupId) {
                    newProdGroup = prodGroup;
                }
            });
            if (newProdGroup) {
                setupForMenu(newProdGroup);
            }
            setCutOffTime(newProdGroupId);
        }
    };

    const getSelectedMenu = function(id) {
        for (let i = 0; i < vm.canteenMenus.length; i++) {
            if (vm.canteenMenus[i].id === id) {
                return vm.canteenMenus[i];
            }
        }
    };

    vm.showMenuWithLeadTime = function() {
        return vm.stickerReportSettings.leadTime > 0;
    };

    vm.showMenuItemWithLeadTime = function() {
        return vm.stickerReportSettings.categoryLeadTime > 0;
    };

    vm.generateStickerReport = function() {
        vm.stickerReportSettings.reportWaiting = true;

        const request = angular.copy(vm.stickerReport);

        request.reportSpec.scheduleInterval = 'once';
        if (vm.isAnytimeMenu) {
            request.startTime = utils.dateTimeToServerDateTimeString(vm.stickerReport.date.startDate, vm.stickerReport.date.startTime); // Start of day
            request.endTime = utils.dateTimeToServerDateTimeString(vm.stickerReport.date.endDate, vm.stickerReport.date.endTime); // End of day
        } else {
            request.startTime = utils.dateToServerDateString(vm.stickerReport.startTime);
        }
        delete (request.date);
        request.reportSpec.prodGroup = {id: request.reportSpec.prodGroup.id};

        const headers = transformHeaderForSave(vm.stickerReportSettings.groupByList);

        request.reportSpec.groupBy = headers;
        request.reportSpec.customFields = headers;

        request.reportSpec.filterMap = transformFiltersForSave();

        reportService.generateStickerReport(request).then(
            (promise) => {
                 poll(promise.id, 'pdf', 'sticker');
             },
             (error) => {
                 handleGenerateReportError(error);
             }
        );
    };

    vm.saveStickerReport = function() {
        if (!validateReport()) {
            return;
        }

        vm.saving = true;

        const request = angular.copy(vm.stickerReportTemplate.reportSpec);

        // Sticker Report is scheduled for cut of time of the menu
        request.scheduleInterval = 'daily';

        const headers = transformHeaderForSave(vm.stickerReportSettings.template.groupByList);

        request.groupBy = headers;
        request.customFields = headers;

        request.filterMap = transformFiltersForSave();
        request.addMenuItemsWithLeadTime = vm.stickerReportTemplate.reportSpec.addMenuItemsWithLeadTime;

        const selectedMenu = getSelectedMenu(request.prodGroup.id);
        let cutoffOffsetInMinutes;
        const isMenuAnytime = !selectedMenu.availability.fixedPreorderType && !selectedMenu.availability.isPreorderable;
        if (isMenuAnytime && vm.days) {
            request.scheduleDay = utils.getSelectedDaysList(vm.days);
        } else {
            request.scheduleDay = reportService.getDefaultDays();
        }
        if (request.addMenuItemsWithLeadTime) {
            cutoffOffsetInMinutes = vm.stickerReportSettings.categoryScheduleTime ? vm.stickerReportSettings.categoryScheduleTime : reportService.getDefaultCutOffTimeOffset(); // Set 09.00 if no value is set
            request.scheduleHour = utils.getCutOff(cutoffOffsetInMinutes).cutoffHour;
            request.scheduleMinute = utils.getCutOff(cutoffOffsetInMinutes).cutoffMinutes;
            request.addMenuWithLeadTime = false;
        } else if (!isMenuAnytime) {
            cutoffOffsetInMinutes = selectedMenu.availability.cutoffOffsetInMinutes ? selectedMenu.availability.cutoffOffsetInMinutes : reportService.getDefaultCutOffTimeOffset(); // Set 09.00 if no value is set
            request.scheduleHour = utils.getCutOff(cutoffOffsetInMinutes).cutoffHour;
            request.scheduleMinute = utils.getCutOff(cutoffOffsetInMinutes).cutoffMinutes;
        }
        request.prodGroup = {id: request.prodGroup.id};

        // Are we updating or creating, if savedReport object passed to modal we are updating, otherwise we are creating
        if (!isSavedReport) {
            request.id = null;
        }

        reportService.saveStickerReport(request, isSavedReport)
            .then((response) => {
                $uibModalInstance.close(true);
            })
            .catch(response => {
                vm.form.stickerReportForm.errors = reportsErrorService
                    .handleServerError(response.data.errors);
            })
            .finally(() => {
                vm.saving = false;
            });
    };

    var validateReport = function() {
        vm.errors = null;
        let valid = true;
        const errors = {};

        if (vm.form.stickerReportForm.name.$invalid) {
        	errors.name = gettextCatalog.getString('Name is required');
            valid = false;
        }

        if (vm.stickerReportTemplate.reportSpec.emailList.length <= 0) {
        	errors.email = gettextCatalog.getString('At least 1 email address is required');
            valid = false;
        }

        vm.form.stickerReportForm.errors = errors;

        return valid;
    };

    vm.addStickerReportEmail = function() {
        // Gets ride of validation warning
        if (vm.form.stickerReportForm.errors && vm.form.stickerReportForm.errors.email) {
            vm.form.stickerReportForm.errors.email = '';
        }

        vm.stickerReportTemplate.reportSpec.emailList.push(vm.stickerReportSettings.email);
        vm.stickerReportSettings.email = '';
    };

    vm.removeStickerReportEmail = function(index) {
        vm.stickerReportTemplate.reportSpec.emailList.splice(index, 1);
    };

    var transformHeaderForSave = function(groupByList) {
        const tmp = [];

        for (const i in groupByList) {
            if (groupByList[i].selected) {
                tmp.push(groupByList[i].name);
            }
        }
        return tmp;
    };

    vm.cancel = function() {
        $uibModalInstance.dismiss('cancel');
    };

    vm.init = function() {
        loadCanteenMenus();

        if (isSavedReport) {
            vm.stickerReportTemplate.reportSpec = savedReport;
            vm.stickerReportTemplate.reportSpec.scheduleDayOfMonth = parseInt(vm.stickerReportTemplate.reportSpec.scheduleDayOfMonth);   // ScheduleDayOfMonth is return as string from server
            utils.setSelectedDays(vm.stickerReportTemplate.reportSpec.scheduleDay, vm.days);
        }
    };

    vm.openFilterPopup = function(isGen) {
        vm.reducedFilterList = [];

        if (isGen) {
            angular.forEach(vm.stickerReportSettings.stickerReportFilters.filtersList, (filter) => {
                if (utils.hasNoValue(filter.prodgroup) || filter.prodgroup.id === vm.stickerReport.reportSpec.prodGroup.id) {
                    vm.reducedFilterList.push(filter);
                }
            });

            if (!vm.stickerReportSettings.filterBy) {
                // Default the selected one to the first in the list
                vm.stickerReportSettings.filterBy = vm.reducedFilterList[0];
            }

            vm.stickerReportSettings.showFilterPopup = true;
        } else {
            angular.forEach(vm.stickerReportSettings.template.stickerReportFilters.filtersList, (filter) => {
                if (utils.hasNoValue(filter.prodgroup) || filter.prodgroup.id === vm.stickerReportTemplate.reportSpec.prodGroup.id) {
                    vm.reducedFilterList.push(filter);
                }
            });

            console.log(' **** ', vm.stickerReportSettings.template.filterBy, vm.reducedFilterList[0]);

            // Checking if is an object because for some reason when it loads template.filter has a string value
            if (!vm.stickerReportSettings.template.filterBy || !_.isObject(vm.stickerReportSettings.template.filterBy)) {
                // Default the selected one to the first in the list
                vm.stickerReportSettings.template.filterBy = vm.reducedFilterList[0];
            }
            vm.stickerReportSettings.showTemplateFilterPopup = true;
        }
     };

    /*
     * Transform tallyReportFilters Add selected key to all options so we can use this as model for toggle on/off
     */
    var transformFiltersForSave = function() {
        const filterList = {};

        if (!utils.hasNoValue(vm.reducedFilterList)) {
            for (let i = 0; i < vm.reducedFilterList.length; i++) {
                // If they are all selected, then we don't send this list to the server.
                // This is important as if new filter values are added (e.g. a new product with a new category), we don't want them excluded
                let areAllSelected = true;

                const tmpFilterList = [];
                const filter = vm.reducedFilterList[i];

                if (filter && filter.options) {
                    for (let j = 0; j < filter.options.length; j++) {
                        if (filter.options[j].selected) {
                            tmpFilterList.push(filter.options[j].name);
                        } else {
                            areAllSelected = false;
                        }
                    }
                }

                if (tmpFilterList.length > 0 && areAllSelected === false) {
                    filterList[[filter.name]] = tmpFilterList;
                } else if (areAllSelected === true && filter.name === 'Category') {
                    vm.stickerReportTemplate.reportSpec.addMenuItemsWithLeadTime = false;
                }
            }
        }

        return filterList;
    };

    const getLatestAvailabilityForCategories = function() {
        let categoryFilter;
        if (vm.reducedFilterList) {
            for (let i = 0; i < vm.reducedFilterList.length; i++) {
                let areAllSelected = true;
                const tmpFilterList = [];
                const filter = vm.reducedFilterList[i];
                if (filter.name === 'Category') {
                    for (let j = 0; j < filter.options.length; j++) {
                        if (filter.options[j].selected) {
                            tmpFilterList.push(filter.options[j].name);
                        } else {
                            areAllSelected = false;
                        }
                    }
                    if (tmpFilterList.length > 0 && areAllSelected === false) {
                        categoryFilter = tmpFilterList.join(',');
                    }
                }
            }
            if (categoryFilter) {
                vm.stickerReportSettings.areAllCategoriesSelected = false;
                menuService.getLatestItemAvailabilityForCategories(vm.stickerReportTemplate.reportSpec.prodGroup.id, categoryFilter).then((promise) => {
                    if (promise.cutoffOffsetInMinutes) {
                        const text = '(' + utils.formatCutOff(promise.cutoffOffsetInMinutes) + ')';
                        vm.stickerReportSettings.categoryLeadTime = utils.getCutOff(promise.cutoffOffsetInMinutes).cutoffDays;
                        vm.stickerReportSettings.categoryCutOffTime = text;
                        vm.stickerReportSettings.categoryScheduleTime = promise.cutoffOffsetInMinutes;
                    }
                });
            } else {
                vm.stickerReportSettings.areAllCategoriesSelected = true;
                vm.stickerReportSettings.categoryLeadTime = 0;
            }
        }
    };

    vm.closeFilterPopup = function() {
        vm.stickerReportSettings.showTemplateFilterPopup = false;
        getLatestAvailabilityForCategories();
    };

    vm.dateOptions = {
        startingDay: $rootScope.merchantInfo.contactDetails.country.weekStartingDay,
        showWeeks: false
    };

    /** Called when day is toggled in daily report */
    vm.changeDayEnabled = function(day) {
        day.selected = !day.selected;
    };

    vm.init();
});



// WEBPACK FOOTER //
// ./src/reports/outlet/shared/sticker.controller.js